import { ChangeDetectionStrategy, Component } from '@angular/core';
import { QrcodeComponent } from '@app/components/qrcode/qrcode.component';
import { TranslateModule } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs/operators';
import { RestaurantTableService } from '@core';

@Component({
  selector: 'app-service-center-amenities',
  standalone: true,
  templateUrl: './service-center-amenities.component.html',
  styleUrls: ['./service-center-amenities.component.scss'],
  imports: [
    QrcodeComponent,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceCenterAmenitiesComponent {

  public readonly wifiCredentials = toSignal(this.restaurantTable.table$.pipe(
    map((table) => {
      if (!table) {
        return undefined;
      }

      return {
        name: table.wifiName,
        password: table.wifiPassword,
      };
    }),
  ));

  public readonly musicControlUrl = toSignal(this.restaurantTable.table$.pipe(
    map((table) => {
      return table?.integrations.find((integration) => {
        return integration.provider === 'bostonPizzaUI';
      })?.credentials.controlMusicUrl;
    }),
    filter((url) => !!url && url.length > 0),
  ));

  constructor(
    private readonly restaurantTable: RestaurantTableService,
  ) {}

}
